import { PictureBe } from '../../image-library/shared/image-model';
import { PartSupplierPruBe, PartListBE } from '../../partsupplierpru/shared/partsupplierpru.model';
import { ConflictTypeEnum } from '../../shared/enums.model';

export class PackageInstructionItem {
    Id: number = -1;
    PIName = '';
    nextPIname = '';
    IssuedAt = '';
    IssuedByUserName = '';
    IssuedByDepartment = '';
    IssuedByEmail='';
    showIssuedByEmail=true;
    ApprovedByUserName = '';
    ApprovedByDepartment = '';
    ApprovedByEmail='';
    showApprovedByEmail='';
    Version = 1;
    StartDate: Date = new Date(Date.now());
    ChangeDate: Date = new Date(Date.now());
    StringStartDate: string = null;
    CategoryId = 1;
    CategoryDescription = 'Package Instruction';
    Weight = 0;
    GrossWeight = 0;
    totalPartWeight=0;
    Comment = '';
    DeviationLength = 0;
    DeviationWidth = 0;
    DeviationHeight = 0;
    DeviationWeight = 0;
    StatusId = 1;
    StatusDescription = '';
    IssuerUserId = '';
    ApproverUserId = '';
    StringCreatedDate: string = null;
    PiCreatedDate: Date = new Date(Date.now());
    PartRelations: Array<PartSupplierPruBe> = [];
    Parts: Array<PackageIntructionPart> = [];
    Pictures: Array<PictureBe> = [];
    LevelInfo: Array<PkgInstrLevelInfo> = [];
    MessageInfo: Array<string> = [];

    PruRelations: Array<PkgInstrPruRelationBE> = [];
    SendPreliminaryToMona = false;

    isUser = false;
    isApprover = false;
    Region = 3;
}

export class PackageIntructionPart {
    Id: number;
    PartId: number;
    PartNo: string;
    Description: string;
    ShortDescripton: string;
    PartStatus: string;
    Weight: number;
    EstimatedWeight: number;
    CalculatedWeight: number;
    MeasuredWeight: number;
    SupplierWeight: number;
    WeightCode: string;
    SupplierId: number;
    SupplierName: string;
    IsMultiPart: boolean;
    ConsistingParts: PartListBE[] = [];
}

export class InstructionsListBE {
    Id: number;
    CreatedDate: Date;
    StartDate: Date;
    PartNo: string;
    PartDescription: string;
    SupplierNo: number;
    SupplierName: string;
    IssuerUserId: string;
    StatusId: number;
    StatusDescription: string;
    IsMultiPart: boolean;
    PruName: string;
    PackagingCode: string;
    HasSupplierRelation: boolean;
    PackagingType:number;
    Region:number;
}

export class PkgInstrLevelInfo {
    constructor(private levelNo: number) {
        this.Level = levelNo;
    }
    InstructionId = 0;
    Level: number = null;
    QuantityOfLevel = 0;
    QuantityInLevel = 0;
    CodeId = 0;
    PackagingCode = '';
    Description = '';
    Length = 0;
    Width = 0;
    Height = 0;
    Weight = 0;
    PartText = '';
    LevelSubNumbering = '';
    LevelToSubNumbering = '';
    LevelComment = '';
    ConstraintCodeId: number = null;
    HasConstraintCode = false;
    IsConstraintCode = false;
    CodeMaterials: Array<PkgInstrLevelMaterialBE> = [];
    AdditionalMaterials: Array<PkgInstrLevelAdditionalMaterialBE> = [];
}

export class PkgInstrLevelMaterialBE {
    Level = 0;
    InstructionId = 0;
    MaterialId = 0;
    Quantity = 0;
    MHNo = '';
    Description = '';
    Weight = 0;
}

export class PkgInstrLevelAdditionalMaterialBE {
    MaterialId = 0;
    InstructionId = 0;
    MHNo = '';
    Description = '';
    Quantity = 0;
    Level = 0;
    Weight = 0;
    PartText = '';
    LevelSubNumbering = '';
    LevelToSubNumbering = '';
}

export class ApprovalBE {
    Message: string;
    InstructionId: number;
    UserId: string;
    StartDate: string;
    Part: string;
    ActivateNow: boolean;
    SupplierPruTypeList: Array<SupplierPruTypeBE> = [];
    InstructionType: number;
    Region: number;

}

export class SupplierPruTypeBE {
    SupplierNo: string;
    pruid: number;

    constructor(sNo: string, Pruid: number) {
        this.pruid = Pruid;
        this.SupplierNo = sNo;
    }
}

export class PkgInstrPruRelationBE {
    PkgInstrId: number;
    PruId: number;
    PartId: number;
    PIName: string;
    ConflictType: ConflictTypeEnum;
    Type:number;

    constructor(pruId: number, pkgInstId: number, partId: number) {
        this.PruId = pruId;
        this.PkgInstrId = pkgInstId;
        this.PartId = partId;
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction/shared/packaging-instruction.model.ts